import { render } from "./Distributions.vue?vue&type=template&id=2d811ce6"
import script from "./Distributions.vue?vue&type=script&lang=js"
export * from "./Distributions.vue?vue&type=script&lang=js"

import "./Distributions.vue?vue&type=style&index=0&id=2d811ce6&lang=css"

import exportComponent from "/home/runner/work/web/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__